import React, { Component } from 'react';

export default class LetSimulate extends Component {
	render() {
		
		return [

			<img src={require('./img/DanArielyLabs.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32 * (264/294)
			}} />,
			<div style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 80,				
				fontSize:24,
			}}>
				<p style={{fontWeight:"bold"}}>
				This is a simulation of a new device setup.  We are interested in what apps you install 
				and don't install when you set up a new phone.
				</p>
				<p style={{fontSize:16}}>
				Don't worry, we will not be collecting any personal information.
				</p>
			</div>

		]
	}

}



// WEBPACK FOOTER //
// ./src/Comp/LetSimulate.js